<template>
  <form @submit.prevent="handleSubmit">
    <div class="login-control">
      <div class="login-control-icon">
        <i class="fal fa-user"></i>
      </div>
      <input
        type="text"
        name="username"
        class="is-hidden-desktop login-input"
        placeholder="Email"
        v-model="username"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{'is-invalid': submitted && errors.has('username') }"
        @change="clearErrors"
        @focus="scrollToBottom()"
      />
      <input
        type="text"
        name="username"
        class="is-hidden-touch login-input"
        placeholder="Email"
        v-model="username"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{'is-invalid': submitted && errors.has('username') }"
        @change="clearErrors"
      />
    </div>

    <div class="invalid-feedback" v-show="submitted && errors.has('username')">
      {{ errors.first('username') }}
    </div>

    <div class="login-control">
      <div class="login-control-icon">
        <i class="fal fa-lock"></i>
      </div>
      <input
        type="password"
        name="password"
        class="is-hidden-desktop login-input"
        placeholder="Lösenord"
        v-model="password"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{ 'is-invalid': submitted && !password }"
        @focus="scrollToBottom()"
      />
      <input
        type="password"
        name="password"
        class="is-hidden-touch login-input"
        placeholder="Lösenord"
        v-model="password"
        v-validate="'required'"
        :disabled="status.loggingIn"
        :class="{ 'is-invalid': submitted && !password }"
      />
    </div>

    <!-- <div v-if="error" class="invalid-feedback">{{ error }}</div> -->

    <div style="text-align: center">
      <button type="submit" class="login-button" :disabled="status.loggingIn">
        <span v-if="!status.logginIn">Logga in</span>
        <span v-if="status.logginIn"><i class="fal fa-spinner-third fa-spin"></i> Loggar in</span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    goToRouteName: {
      type: String
    }
  },

  data () {
    return {
      error: null,
      username: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('auth', ['status'])
  },
  methods: {
    ...mapActions('auth', ['login']),

    clearErrors () {
      this.$validator.reset()
    },

    scrollToBottom () {
      var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

      if (!iOS) {
        setTimeout(() => {
          window.scrollTo(0, 99999)
        }, 300)
      }
    },

    handleSubmit (e) {
      this.submitted = true
      const { username, password } = this
      if (username && password) {
        this.$store.state.loading = true
        this.login({ username, password })
          .then(() => {
            this.$emit('onSuccess')

            if (this.goToRouteName) {
              this.$router.push({ name: this.goToRouteName })
            }
          })
          .catch(() => {
            this.$toast('Felaktiga inloggningsuppgifter', 'error')
          })
          .finally(() => {
            this.$store.state.loading = false
          })
      } else {
        this.$toast('Fyll i användarnamn och lösenord', 'error')
        // this.$alertOptions({
        //   title: 'Felaktig inloggning',
        //   text: 'Du måste fylla i både email och lösenord.',
        //   icon: 'warning',
        //   confirmButtonText: 'Ok',
        //   allowOutsideClick: false
        // })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/LoginForm.vue